/**
 * This file is auto-generated from ChatMessageDocumentRow.loc.yaml
 * Do not edit this file directly. Edit the source file instead.
 */

import type { Translation } from '@nzyme/i18n-core';

export const downloadFile: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Download file';
        case 'pl':
            return 'Pobierz plik';
    }
};
